/** Default page size for paginated lists (UIPaginationBar, list hooks, etc.). */
export const UI_TABLE_DEFAULT_PAGE_SIZE = 10;

/** Default rows-per-page choices for tables (DataGrid footer, pagination selects, etc.). */
export const UI_TABLE_DEFAULT_ROWS_PER_PAGE_OPTIONS = Object.freeze([
  10, 20, 30, 50, 100,
]);

/**
 * UITable: use built-in defaults, optionally extended; or pass `rowsPerPageOptions` to replace entirely.
 *
 * @param {number[] | undefined} rowsPerPageOptions — if set, returned as-is (full override).
 * @param {number[] | undefined} extraRowsPerPageOptions — merged with defaults when `rowsPerPageOptions` is omitted.
 * @returns {number[]}
 */
export function resolveRowsPerPageOptions(rowsPerPageOptions, extraRowsPerPageOptions) {
  if (rowsPerPageOptions !== undefined) {
    return rowsPerPageOptions;
  }
  const base = [...UI_TABLE_DEFAULT_ROWS_PER_PAGE_OPTIONS];
  if (!extraRowsPerPageOptions?.length) {
    return base;
  }
  return [...new Set([...base, ...extraRowsPerPageOptions])].sort((a, b) => a - b);
}

/**
 * Pagination / MUI Select: keeps the current page size selectable even if it is not in the preset list
 * (e.g. legacy URL or API state). Pass a custom `pageSizeOptions` when the screen needs a different preset;
 * use another helper or inline logic only if behavior must diverge.
 *
 * @param {ReadonlyArray<number>|number[]|undefined} pageSizeOptions
 * @param {number} currentPageSize
 * @returns {number[]}
 */
export function withSelectableCurrentPageSize(pageSizeOptions, currentPageSize) {
  const options = Array.isArray(pageSizeOptions) ? [...pageSizeOptions] : [];
  if (options.length === 0) {
    return Number.isFinite(currentPageSize) ? [currentPageSize] : [];
  }
  if (!Number.isFinite(currentPageSize) || options.includes(currentPageSize)) {
    return options;
  }
  return [...options, currentPageSize].sort((a, b) => a - b);
}
